<template>
    <TopProductsCarousel :blok="blok" :airport="airport" :products="products" :section-config="sectionConfig" />
</template>

<script lang="ts" setup>
import TopProductsCarousel from '~/components/sections/AprProductsCarousel.vue';
import type { IProductsSectionConfig } from '~/../types/ProductsCarousel';

defineProps<{
    blok: any;
    airport: any;
    products: any;
}>();

const sectionConfig: IProductsSectionConfig = {
    title: 'title',
    subtitle: {
        subtitleName: 'content',
        subtitleType: 'text',
    },
    cardType: 'HotelOrParking',
};
</script>

<style scoped lang="postcss"></style>
